/**
 * @file 套餐容器组件
 */
import React, {useMemo} from 'react';
import {LevelCard} from './LevelCard';
import styles from './PlanContainer.module.less';
import {useHorizontalScroll} from './hooks/useHorizontalScroll';
import type {MembershipPlan, MemberLevelItem} from '@/services/commerce/membership/interface';
import Icon from '@/components/common/Icon';
import Button from '@/components/common/Button';
import {useMemberInfo} from '@/commerce/benefit/hooks/useMemberInfo';
import {createCx} from '@/utils/cx';

const cx = createCx(styles);

interface PlanContainerProps {
    plan?: MembershipPlan;
    onClick: (plan: MemberLevelItem) => void;
}

export const PlanContainer: React.FC<PlanContainerProps> = ({plan, onClick}) => {
    const {containerRef, canScrollLeft, canScrollRight, scrollLeft, scrollRight} =
        useHorizontalScroll();
    // 点击卡片触发回调
    const handleCardClick = (level: MemberLevelItem) => {
        onClick(level);
    };

    // 获取用户当前的等级信息
    const {memberInfo} = useMemberInfo();

    // 缓存当前订阅的等级标识
    const currentLevelKey = useMemo(() => {
        if (!memberInfo || plan?.subscriptionType !== memberInfo.subscriptionType) {
            return null;
        }
        return memberInfo.memberLevel;
    }, [memberInfo, plan?.subscriptionType]);

    return (
        <div className={styles.planContainer}>
            {/* 滚动容器 */}
            <div ref={containerRef} className={styles.scrollContainer}>
                {plan?.levels.map((level) => {
                    return (
                        <LevelCard
                            key={level.memberLevel}
                            level={level}
                            showSubscribeTag={level.memberLevel === currentLevelKey}
                            onClick={() => handleCardClick(level)}
                        />
                    );
                })}
            </div>

            {/* 左箭头 */}
            {canScrollLeft && (
                <Button
                    onClick={scrollLeft}
                    size="mini"
                    className={cx('arrowLeft', 'arrowBtn')}
                    icon={<Icon name="AijBasicZuo1" size={20} style={{lineHeight: 0}} />}
                />
            )}

            {/* 右箭头 */}
            {canScrollRight && (
                <Button
                    onClick={scrollRight}
                    size="mini"
                    className={cx('arrowRight', 'arrowBtn')}
                    icon={<Icon name="AijBasicYou1" size={24} style={{lineHeight: 0}} />}
                />
            )}
        </div>
    );
};
